export default __webpack_public_path__ + "static/media/logout.6d8cb838.svg";